import { Button } from '@mui/material'
import { GridRowId, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid'
import React, { FC } from 'react'
import { FiPlus, FiTrash2 } from 'react-icons/fi'

interface ToolbarProps {
    setIsShown: (state: boolean) => void;
    selectedID: GridRowId[];
    setShowDelete: (state: boolean) => void
}

export const ClientPartnersToolbar: FC<ToolbarProps> = ({ setIsShown, selectedID, setShowDelete }) => {
    return (
        <div className='p-6'>
            <div className="flex  justify-between">
                <div className='text-xl'>Clients & Partners</div>
                <GridToolbarContainer>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <Button size="small" color="primary" startIcon={<FiPlus />} onClick={() => setIsShown(true)}>Add Client or Partner</Button>
                    {selectedID.length > 0 && <Button size="small" color="primary" startIcon={<FiTrash2 />} onClick={() => setShowDelete(true)}>Delete</Button>}
                </GridToolbarContainer>
            </div>
        </div>
    )
}
